// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"902":"10e5cfb3","977":"9b8ae576"}[chunkId] + ".chunk.js";
};